import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "./DrawerNavigation";

export const CustomTitle = ({ setCurrentLink }: { setCurrentLink: React.Dispatch<React.SetStateAction<NavLink>> }) => {
	const location = useLocation();

	useEffect(() => {
		const routeTitles: { [key: string]: string } = {
			"/login": "Login",
			"/register": "Register",
			"/registration-notice": "Register",
			"/forgot-password": "Forgot Password",
			"/reset-password": "Reset Password",
			"/jobs/dashboard": "Jobs Dashboard",
			"/jobs/ready": "Mark Jobs Ready",
			"/jobs/submit": "Submit Jobs",
			"/logout": "Logout",
			"/": "Login",
			"/jobs/": "Individual Job Details",
			"/home": "Rogo Portal",
			"/admin/sortshp": "Reorganize Shapefiles",
			"/admin/import": "Import Settings",
			"/admin/robots": "Robots",
			"/admin/job-diagnostics": "Job Diagnostics",
			"/admin/exe-mission-validation": "Exe Mission Validation",
			"/admin/data-sendback-issues": "Data Sendback Issues",
			"/admin/agrian-issues": "Agrian Issues",
			"/admin/deal-creator": "Deal Creator",
			"/admin/branch-matcher": "Branch Matcher",
			"/admin/deal-matcher": "Deal Matcher",
			"/admin/password-generator": "Rogo Login Generator",
			"/admin/mission-control-passwords-generator": "Mission Control Passwords",
			"/admin/mission-control-logs": "Mission Control Logs",
			"/admin/geofile-converter": "GeoFile Converter",
			"/profile": "Profile",
		};

		let title = routeTitles[location.pathname] || "";

		if (title == "" && location.pathname.includes("/jobs/")) {
			title = "Individual Job Details";
		}

		document.title = title;

		setCurrentLink({ to: location.pathname, text: title });
	}, [location, setCurrentLink]);

	return null;
};
